const Redirect = (path) => {
    // let myPath = path.startsWith('/') ? path : '/' + path;
    // myPath = myPath.startsWith('/school/') ? myPath : '/school' + myPath;
    // if (myPath == '/school/') myPath = '/school/school';
    window.location = path;
};

export default Redirect;